import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useLocation } from 'react-router-dom';

import { NAVIGATE_TO } from '@trader/constants';
import { useNavigation, usePurchase } from '@trader/hooks';
import { useI18next } from '@trader/services';
import {
  Header,
  BalanceDetails,
  Layouts,
  Icon,
  IconButton,
  TopMenu,
  MobileMenu,
} from '@trader/components';

import * as Styled from './styled';

export const TopBar: React.FC = observer(() => {
  const { navigateTo } = useNavigation();
  const location = useLocation();
  const purchase = usePurchase();

  const { translate } = useI18next();
  const [state, setState] = useState({
    isOpenLeftMenu: false,
    isOpenBalance: true,
    isOpenMenu: false,
  });

  const toggleState = (stateKey: keyof typeof state) => () => {
    setState(prev => ({
      ...prev,
      [stateKey]: !prev[stateKey],
    }));
  };

  const navigateToDashboard = () => {
    navigateTo(NAVIGATE_TO.main.dashboard);
  };

  return (
    <React.Fragment>
      <Header>
        <Styled.Menu>
          {!location.pathname.includes('dashboard') && (
            <IconButton onClick={navigateToDashboard} iconType='arrowLeft' />
          )}
          <IconButton
            onClick={toggleState('isOpenLeftMenu')}
            iconType='search'
          />
        </Styled.Menu>
        <Styled.Logo>
          <Icon iconType={import.meta.env.VITE_LOGO} />
        </Styled.Logo>
        <Styled.Menu>
          <TopMenu />
        </Styled.Menu>
        <Styled.MobileMenu>
          <IconButton
            iconType='menu'
            id='menu-mobile'
            onClick={toggleState('isOpenMenu')}
          />
        </Styled.MobileMenu>
        <Styled.RightSide>
          <Layouts />
          <Styled.BalanceDetails $isOpenPortfolio={state.isOpenBalance}>
            {state.isOpenBalance && (
              <Styled.Toggle
                isSingleIcon
                variant='text'
                onClick={toggleState('isOpenBalance')}
              >
                <Icon iconType={'currency'} />
                <Icon style={{ width: 7 }} iconType={'arrowRight'} />
              </Styled.Toggle>
            )}
            <BalanceDetails isShowDetails={state.isOpenBalance} />

            {!state.isOpenBalance && (
              <Styled.Toggle
                isSingleIcon
                variant='text'
                onClick={toggleState('isOpenBalance')}
              >
                <Icon style={{ width: 7 }} iconType={'arrowLeft'} />
                <Icon iconType={'currency'} />
              </Styled.Toggle>
            )}
          </Styled.BalanceDetails>
          <Styled.AddFunds
            disabled={purchase.isDisabled}
            $isOpenPortfolio={state.isOpenBalance}
            onClick={purchase.action}
            variant='text'
          >
            {translate(purchase.title)}
          </Styled.AddFunds>
          <TopMenu />
        </Styled.RightSide>
      </Header>
      <MobileMenu
        side='left'
        isOpen={state.isOpenLeftMenu}
        onToggle={toggleState('isOpenLeftMenu')}
      />
      <MobileMenu
        isOpen={state.isOpenMenu}
        onToggle={toggleState('isOpenMenu')}
      />
    </React.Fragment>
  );
});
